import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";

import Loader from "../../common/loader";
import { formateDate, showStatus } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { RunnerDetails } from "../../services/runner.services";

const ViewRunner = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const [runnerData, setRunnerData] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Runner"), url: "/admin/temple-runner/list/1" },
    { title: t("View"), url: "" },
  ];

  useEffect(() => {
    RunnerDetails(params.id)
      .then((response) => {
        setRunnerData(response?.data || {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t("View Runner")}
                </h6>
              </div>

              {runnerData && Object.keys(runnerData).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Runner Name")}</th>
                          <td className="text-capitalize">
                            {runnerData.name || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Runner Email")}</th>
                          <td>{runnerData.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Runner Phone")}</th>
                          <td>{runnerData.phone_number || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("City")}</th>
                          <td>{runnerData.city || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("State")}</th>
                          <td>{runnerData.state || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Country")}</th>
                          <td>{runnerData.country || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Runner Image")}</th>
                          <td>
                            {runnerData.profile_image ? (
                              <img
                                src={runnerData.profile_image}
                                alt="Runner"
                                style={{
                                  width: "150px",
                                  height: "auto",
                                  borderRadius: "6px",
                                  border: "1px solid #ddd",
                                }}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Status")}</th>
                          <td>
                            {runnerData?.status
                              ? toHtml(showStatus(1))
                              : toHtml(showStatus(0))}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Created At")}</th>
                          <td>
                            {runnerData.createdAt
                              ? formateDate(runnerData.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
            <div className="ml-4 back-button mx-0">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() => navigate("/admin/temple-runner/list/1")}
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewRunner;
